// ESM-Huelle um lib/scripts/pos/CLS_CReceiptPrinter.js (Phase 4, Welle 3) -
// Druck/RKSV, eines der sechs beim BonManager-Refactor extrahierten
// Module (Prototype-Mixin, wird im CBonManager-Konstruktor an die
// Instanz gebunden). Prototype-Stil bleibt vorerst.
// Strict-Mode-Fix (ESM): diese Namen wurden im Classic-Sloppy-Mode als
// implizite window-Globals angelegt (Zuweisung ohne var) - in Modulen
// wirft das ReferenceError. Modul-weite Deklaration stellt das alte
// Verhalten (dateiuebergreifend ungenutzte Temp-Variablen) her.
var text;

import { eBelegVorDruck } from '../../receipt/ebeleg.js';


function CReceiptPrinter() {}

// RKSV (Ruling 24): Belegerzeugung GLOBAL serialisiert. Die ganze Folge
// "MAX(ReceiptID) -> new CReceipt -> checkPrevReceipt (Null-/SZR-Belege) ->
// signieren -> insertBon" eines Belegs beginnt erst, wenn der vorige Beleg
// gespeichert ist - sonst bekommen zwei gleichzeitige Belege dieselbe
// Belegnummer im Payload und verketten beide auf denselben Vorbeleg.
// Nur jQuery-Deferreds (tools/MODERNISIERUNG.md Regel 4). Freigabe IMMER:
// nach dem Speichern, bei Fehler/Ausnahme und spaetestens nach 90 s (laenger
// als das 60-s-Netz des Signaturwechsels in receipt.js).
var belegReihe = null;
var BELEG_REIHE_MAX_MS = 90000;

function inBelegReihe(arbeit) {
    var vorher = belegReihe || jQuery.Deferred().resolve().promise();
    var fertig = jQuery.Deferred();
    belegReihe = fertig.promise();
    vorher.always(function () {
        var uhr = setTimeout(function () {
            log.add(1, "Error", "RKSV", "Beleg-Reihe: Beleg nach " + (BELEG_REIHE_MAX_MS / 1000) + " s nicht fertig - naechster Beleg freigegeben");
            fertig.resolve();
        }, BELEG_REIHE_MAX_MS);
        var freigeben = function () {
            clearTimeout(uhr);
            fertig.resolve();
        };
        try {
            arbeit(freigeben);
        } catch (e) {
            log.add(1, "Error", "RKSV", "Beleg-Reihe: " + (e && e.message));
            freigeben();
            throw e;
        }
    });
}

CReceiptPrinter.MELDUNG_NICHT_GESPEICHERT = "Beleg konnte nicht gespeichert werden! Bitte Support anrufen.";

CReceiptPrinter.prototype.AddEntryPOSREG = function () {

    var defret = $.Deferred();
    var BonManagerClass = this;
    if (this.isCashPayment() && POS.Smartcard && POS.Smartcard.ausserBetrieb) {
        // Nacharbeit B4: Rueckfallnetz - addEntryPAY verweigert den Barumsatz
        // schon vorher. Kein Beleg, kein Ausfall-Beleg.
        POS.Smartcard.ausserBetriebMelden();
        defret.reject("Kasse ausser Betrieb");
        return defret.promise();
    }
    if (this.isCashPayment()) { //nicht Zentrale, Lieferschein,Personal
        inBelegReihe(function (freigeben) {
        $.when(POS.SQLiteCon.lastInsertBonRegId()).done(function (ID) {
            var Receipt = new CReceipt(parseInt(ID) + 1);
            $.when(Receipt.defreturn).done(function (c) {

                $.when(Receipt.checkPrevReceipt()).then(function (first) {

                    var plaindata = Receipt.prepareSignatureData(BonManagerClass);

                    $.when(Receipt.signDataSentence(plaindata)).then(function (sigValueHex) {
                        BonManagerClass.currentReceipt = Receipt;
                        PreviousReceipt = Receipt;
                        var SigTrans = new CReceiptTransaction();
                        // Aufrufer wie bisher sofort bedienen; die Reihe gibt erst
                        // frei, wenn der Beleg in BONREG steht.
                        $.when(SigTrans.insertBon(Receipt)).always(freigeben);
                        defret.resolve(true);
                    }, freigeben);
                }, function (grund) {
                    // Fix-Runde 2: faelliger Nullbeleg (MVC/JVC/AZR/SZR) nicht
                    // signiert/gespeichert - der Barbeleg scheitert sauber, mit Meldung.
                    freigeben();
                    if (grund === "Kasse ausser Betrieb") POS.Smartcard.ausserBetriebMelden();
                    else {
                        log.add(1, "Error", "RKSV", "Beleg nicht erstellt: " + grund);
                        POS.message.show(CReceiptPrinter.MELDUNG_NICHT_GESPEICHERT, "warning", "OK");
                    }
                    defret.reject(grund);
                });
            }).fail(freigeben);
        }).fail(freigeben);
        });
    } else {
        // Kein Barumsatz (Zentrale, Lieferschein, Personal): kein RKSV-Beleg.
        // Den des vorigen Barbons nicht stehen lassen - sonst trugen
        // Gluecksnummer, e-Beleg (QR/JWS) und Hello-Again-receipt_nr dessen
        // Daten (Testkasse 20.10.2026).
        BonManagerClass.currentReceipt = null;
        defret.resolve(false);
    }
    return defret.promise();

}

CReceiptPrinter.prototype.printBarcode = function (barcodeNumber, price, prodName) {

    var defret = $.Deferred();
    if (POS.EnvProperties.PRINTER == "NO")
        return 0;
    var BonManagerClass = this;
    var priceString = float2StringD2(price) + " &euro;";

    Printer.addLine("A", 4, false, 0);
    Printer.addElement(prodName, 8, 2, true, 0, 41);
    Printer.addLine("B", 1, false, 2);

    Printer.addLine("A", 6, false, 0);
    Printer.addElement(priceString, 7, 2, true, 0, 14);
    Printer.addLine("B", 1, false, 1);
    //                        (size, group, code, text, feed)
    Printer.addBarcodeLine("AA", 2, 72, barcodeNumber, 1); // Documentation error!!! The right code number in the second group is always one unit less! (73->72)

    Printer.addLine("A", 1, false, 0);
    Printer.addElement(barcodeNumber.toString(), 20, 2, true, 0, 41);
    Printer.addLine("B", 1, false, 2);

    Printer.addDivisionLine();

    var def = $.Deferred();
    var is = Object.keys(this.currentBon);
    var iterator = function it(x) {

        if (x < is.length) {
            var i = is[x];
            if ((BonManagerClass.currentBon[i].type == "POS" && !BonManagerClass.currentBon[i].cancelled) ||
                (BonManagerClass.currentBon[i].type == "FPR" || BonManagerClass.currentBon[i].type == "PDN" ||
                    BonManagerClass.currentBon[i].type == "REC") && BonManagerClass.currentBon[i].cancelled == false) {
                BonManagerClass.redrawBon(BonManagerClass.currentBon[i], true);
                iterator(x + 1);
                return;
            } else {
                iterator(x + 1);
                return;
            }
        } else {
            def.resolve();
            return;
        }
    }
    iterator(0);
    $.when(def).done(function (c) {
        Printer.addDivisionLine();

        var makerText = "Erstellt von " + BonManagerClass.Main.userProps.Name;

        Printer.addLine("A", 1, false, 0);
        Printer.addElement(makerText, 20, 2, true, 0, 41);
        Printer.addLine("B", 1, false, 2);

        var now = new Date();

        var rand1 = getRandomNumber(10, 99);
        var rand2 = getRandomNumber(100, 999);
        var rand3 = getRandomNumber(10, 99);

        var dateTime = rand1 + expandInteger(now.getDate(), 2) + rand2 +
            expandInteger(now.getMonth() + 1, 2) + rand3 + " " +
            expandInteger(now.getHours(), 2) + ":" + expandInteger(now.getMinutes(), 2);

        Printer.addLine("A", 2, false, 0);
        Printer.addElement(dateTime, 20, 2, true, 0, 41);

        Printer.print();
        defret.resolve();
    });
    return defret.promise();
}

CReceiptPrinter.prototype.printInvertedBon = function () {

    for (var Cnt in this.currentBon) {
        this.currentBon[Cnt].amount = -1 * this.currentBon[Cnt].amount;
    }

    return this.printBon();
}

CReceiptPrinter.prototype.printCustomerData = function () {

    if (POS.EnvProperties.PRINTER == "NO")
        return 0;

    var BonManagerClass = this;
    var defret = $.Deferred();

    $.when(Trans.getCustomerData(this.currentCustomerId)).then(function (customerData) {
        if (BonManagerClass.currentCustomerId)
            var lineHeight = 0;
        else
            lineHeight = 3;

        if (BonManagerClass.isReclamationBon && (BonManagerClass.printMode == "bill" || BonManagerClass.printMode == "billcopy"))
            var textForWhat = POS.lang.getText("LABELS", "CUSTOMER_DATA_COMPLAIN");
        else
            textForWhat = null;

        if (textForWhat) {
            Printer.addLine("A", 2, false, 0);
            Printer.addElement(textForWhat, 20, 2, true, 0, 41);
            Printer.addLine("B", 1, false, 1);
        }

        var headText = BonManagerClass.currentCustomerId ? POS.lang.getText("LABELS", "REGISTERED_CUSTOMER") : POS.lang.getText("LABELS", "CUSTOMER_DATA");

        Printer.addLine("A", 1, false, 0);
        Printer.addElement(headText + ":", 20, 2, true, 0, 41);
        Printer.addLine("B", 1, false, 2);

        Printer.addLine("A", 1, false, lineHeight);
        Printer.addElement(POS.lang.getText("LABELS", "CUST_CARD_NUMBER") + ":", 0, 0, false, 0, 10);
        Printer.addElement(customerData.cardNumber, 11, 0, false, 11, 40);
        if (BonManagerClass.printMode != "bill") {
        }
        if (BonManagerClass.currentCustomerId)
            Printer.addLine("B", 1, false, 2);

        defret.resolve();
    });
    return defret.promise();
}

//print Bon and create bontext for hello again

CReceiptPrinter.prototype.printBon = function (voucher, withQRCode, ReceiptID) {

    if (POS.EnvProperties.PRINTER == "NO")
        return 0;

    var BonManagerClass = this;

    var bontext = ""; //Rechnung als Text
    // print modes:
    //      normal, boncopy, paydown, bill, billcopy, cancelprotocoll, cancellation
    var defret = $.Deferred();

    // Beleg-Aufbau, ehemals als 10+ Ebenen tiefe $.when(...).done(function(){
    // $.when(...).done(function(){ ... }) })-Pyramide geschrieben. Hier als
    // flache Kette benannter Schritte, weiterhin jQuery-Deferred-basiert
    // (kein async/await). bontext/total/showPPUNote/isDelivery/
    // sumProdRebates werden wie zuvor als gemeinsamer, ueber die ganze
    // Funktion mutierter Zustand gehalten (jetzt als Closure-Variablen statt
    // durch Verschachtelung sichtbar) - jeder Ausdruck/jede Bedingung/jeder
    // Text wortwoertlich aus der vorherigen Fassung uebernommen.
    var showPPUNote = false;
    var isDelivery = false;
    var sumProdRebates = 0;
    var total = 0;

    function stepPrintHeader() {
        if (BonManagerClass.printMode == "cancelprotocol") return 0;
        return $.when(Printer.head()).then(function () {
            Printer.addLine("B", 1, false, 0);
            text = POS.lang.getText("LABELS", "ATU") + ": " + POS.ATU;
            Printer.addElement(text, 55, 1, false, 36, 55);

            return $.when(BonManagerClass.wholeNetto()).then(function (net) {
                if (BonManagerClass.isReclamationBon || BonManagerClass.printMode == "cancellation" || net >= 150 || BonManagerClass.currentCustomerId) {
                    return BonManagerClass.printCustomerData();
                }
            });
        });
    }

    function stepReclamationHeaderAndScanEntries() {
        if (BonManagerClass.isReclamationBon && (BonManagerClass.printMode == "bill" || BonManagerClass.printMode == "billcopy" ||
                BonManagerClass.printMode == "normal" || BonManagerClass.printMode == "boncopy")) {
            Printer.addLine("B", 1, false, 2);
            Printer.addLine("B", 1, false, 6);
            Printer.addDivisionLine();

            Printer.addLine("A", 1, false, 1);
            Printer.addElement(POS.lang.getText("LABELS", "DATA_ONLY_FOR_FILE"), 20, 2, true, 0, 41);
            Printer.addLine("B", 1, false, 1);
        }

        for (var i in BonManagerClass.currentBon) {
            var entry = BonManagerClass.currentBon[i];
            if (entry.type == "PAY" && entry.cancelled == false &&
                (entry.text1 == POS.lang.getText("LABELS", "PPU") || entry.text1 == "PPU")) {
                showPPUNote = true;
                break;
            }
            if (entry.type == "PAY" && entry.cancelled == false &&
                (entry.text1 == POS.lang.getText("LABELS", "DELIVERY_BILL") || entry.text1 == "DLP")) {
                isDelivery = true;
                break;
            }
            if (entry.type == "POS" && entry.cancelled == false && entry.product.correctedPrice > entry.product.price) {
                sumProdRebates += entry.quantity * (entry.product.correctedPrice - entry.product.price);
            }
        }

        if (!showPPUNote) return;

        Printer.addLine("B", 1, false, 2);
        var r;
        if (BonManagerClass.displayMode == "purchase")
            r = Trans.getPurchaserName(BonManagerClass.displayTarget.purchaserId);
        else
            r = Trans.getPurchaserNameFromBONE(BonManagerClass.currentBonId);

        return $.when(r).then(function (purchaser) {
            var purchaserName = purchaser;
            Printer.addLine("A", 1, false, 1);
            text = POS.lang.getText("LABELS", "PPU_BY") + " " + purchaserName;
            Printer.addElement(text, 20, 2, true, 0, 41);
        });
    }

    function stepBuildHeaderTextAndEntries() {
        Printer.addLine("B", 1, false, 1);

        text = "";
        switch (BonManagerClass.printMode) {
        case "cancelprotocol":
            text = POS.lang.getText("LABELS", "CANCEL_PROTOCOL");
            break;
        case "cancellation":
            text = POS.lang.getText("LABELS", "CANCELLATION");
            break;
        case "boncopy":
            if (!isDelivery)
                text = POS.lang.getText("LABELS", "BON_COPY");
            else
                text = POS.lang.getText("LABELS", "DELIVERY_COPY");
            break;
        case "billcopy":
            if (!isDelivery)
                text = POS.lang.getText("LABELS", "BILL_COPY");
            else
                text = POS.lang.getText("LABELS", "DELIVERY_COPY");
            break;
        case "paydown":
            text = POS.lang.getText("LABELS", "PAYDOWN_BILL");
            break;
        case "yearly_voucher":
            text = POS.lang.getText("LABELS", "YEARLY_VOUCHER");
            break;
        default: // cases "normal", "bill"
            if (!isDelivery)
                text = POS.lang.getText("LABELS", "BILL");
            else
                text = POS.lang.getText("LABELS", "DELIVERY");
            break;
        }
        if (text) {
            Printer.addLine("A", 2, false, 0);
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("B", 1, false, 1);
            bontext = "MEIN EINKAUF\r\n"; //bontext + text;
        }

        if (BonManagerClass.printMode == "paydown") {
            Printer.addLine("B", 1, false, 1);
            Printer.addBarcodeLine("66", 2, 72, BonManagerClass.barcode, 1);
        }

        if ((BonManagerClass.printMode == "cancelprotocol" || BonManagerClass.printMode == "cancellation") &&
            BonManagerClass.cancelReasonText != "") {
            Printer.addLine("A", 1, false, 0);
            text = POS.lang.getText("LABELS", "CANCEL_REASON_TEXT") + ": " +
                BonManagerClass.cancelReasonText;
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("B", 1, false, 2);
            bontext = bontext + text;
        }

        if (BonManagerClass.currentReceipt && BonManagerClass.printMode != "cancelprotocol" && BonManagerClass.printMode != "cancellation" && BonManagerClass.printMode != "yearly_voucher") {
            if (BonManagerClass.currentReceipt.receiptIdentifier < 10){
                var luckyNumber = BonManagerClass.currentReceipt.receiptIdentifier;
            } else {
                var tempId = BonManagerClass.currentReceipt.receiptIdentifier.toString();
                luckyNumber = tempId[tempId.length - 2] + tempId[tempId.length - 1];
                luckyNumber = parseFloat(luckyNumber);
            }

            text = POS.lang.getText("LABELS", "YOUR_LUCKY_NUMBER") + ": " + luckyNumber;
            Printer.addLine("A", 1, false, 0);
            Printer.addElement(text, 20, 2, true, 0, 41);
        }

        Printer.addDivisionLine();

        var def3 = $.Deferred();
        var is = Object.keys(BonManagerClass.currentBon);
        bontext = bontext + "\r\n";
        var iterator = function it(x) {
            if (x < is.length) {
                var i = is[x];
                if (BonManagerClass.currentBon[i].type == "POS" || (BonManagerClass.currentBon[i].type == "FPR" ||
                        BonManagerClass.currentBon[i].type == "PDN" || BonManagerClass.currentBon[i].type == "REC") &&
                    BonManagerClass.currentBon[i].cancelled == false) {
                    $.when(BonManagerClass.redrawBon(BonManagerClass.currentBon[i], true)).done(function () {
                        var E = BonManagerClass.currentBon[i];
                        if (E.cancelled == false) {
                        }
                        iterator(x + 1);
                        return;
                    });
                } else if ((BonManagerClass.currentBon[i].type == "PAY") && BonManagerClass.currentBon[i].cancelled == false) {
                    total = total + Number(BonManagerClass.currentBon[i].amount);
                    iterator(x + 1);
                    return;
                } else if ((BonManagerClass.currentBon[i].type == "RET") && BonManagerClass.currentBon[i].cancelled == false) {
                    total = total - Number(BonManagerClass.currentBon[i].amount);
                    iterator(x + 1);
                    return;
                } else {
                    iterator(x + 1);
                    return;
                }
            } else {
                bontext = bontext + "\r\nSumme: " + total + " EUR\r\n\r\n";
                def3.resolve();
                return;
            }
        }

        iterator(0);
        return def3.promise();
    }

    function stepRedrawSumAndVoucher() {
        Printer.addDivisionLine();

        return $.when(BonManagerClass.redrawBonSum(true)).then(function () {
            Printer.addDivisionLine();
            // Card payment information
            if (voucher != null && typeof voucher != "undefined") {
                return $.when(voucher.printBon(Printer)).then(function () {
                    Printer.addDivisionLine();
                });
            }
        });
    }

    function stepBonIdAndUserParams() {
        Printer.addLine("B", 1, false, 0);

        return $.when(Trans.getPosBonId(BonManagerClass.currentBonId)).then(function (bonID) {
            if (BonManagerClass.printMode == "cancellation")
                BonManagerClass.currentBonPOSId = bonID;

            if (BonManagerClass.currentBonPOSId > 0)
                var nrText = POS.lang.getText("LABELS", "BILL_NUMBER");
            else
                nrText = POS.lang.getText("LABELS", "RECEIPT_NUMBER");

            var text = POS.lang.getText("LABELS", "CASHBOX") + " |" +
                nrText + "| " + POS.lang.getText("LABELS", "USER") + " |   " +
                POS.lang.getText("LABELS", "DATE") + "    | " +
                POS.lang.getText("LABELS", "TIME");

            Printer.addElement(text, 4, 0, false, 4, 55);
            bontext = bontext + text + "\r\n";
            Printer.addLine("B", 1, false, 0);
            var now = BonManagerClass.DateTime;
            if (!now)
                now = new Date();
            if ((ReceiptID && (BonManagerClass.isCashPayment())) || (BonManagerClass.printMode == "yearly_voucher") || (BonManagerClass.printMode == "null_receipt")) {
                var BonId = expandInteger(ReceiptID, 9);
            } else if (BonManagerClass.currentBonPOSId > 0) {
                BonId = expandInteger(BonManagerClass.currentBonPOSId, 9);
            } else {
                BonId = expandInteger(BonManagerClass.currentBonId, 9);
            }
            return $.when(Trans.getUserParamsFromBon(BonManagerClass.currentBonId)).then(function (userParams) {
                return finishBonText(userParams, now, BonId);
            });
        });
    }

    function finishBonText(userParams, now, BonId) {
        var userName = userParams["Name"];
        var userLogin = userParams["Login"];

        text = expandInteger(POS.POSId, 5) + " | " + BonId + " | ";
        text += expandInteger(userLogin, 8) + " | " + expandInteger(now.getDate(), 2) +
        "." + expandInteger(now.getMonth() + 1, 2) +
        "." + now.getFullYear() + " |  " + expandInteger(now.getHours(), 2) +
        ":" + expandInteger(now.getMinutes(), 2);
        Printer.addElement(text, 4, 0, false, 4, 55);
        Printer.addLine("B", 1, false, 3);
        bontext = bontext + text + "\r\n";

        if (BonManagerClass.prepaidCardCredits) {
            var allCards = BonManagerClass.prepaidCardCredits.split("*");
            for (var i = 0; i < allCards.length; i++) {
                var cardData = allCards[i].split(";");
                var cardNumber = cardData[0];
                var cardCredit = float2StringD2(cardData[1]);

                Printer.addLine("A", 1, false, 0);
                text = POS.lang.getText("LABELS", "CREDIT_IN_PREPAID_CARD") + " " + cardNumber + ": " + cardCredit + " &euro;";
                Printer.addElement(text, 20, 2, true, 0, 41);
            }
            Printer.addLine("B", 1, false, 3);
            bontext = bontext + text;
        }

        Printer.addLine("B", 1, false, 0);
        text = POS.lang.getText("LABELS", "SERVED_BY") + " " + BonManagerClass.getDisplayName(userName);
        Printer.addElement(text, 27, 2, false, 0, 55);
        bontext = bontext + text;
        Printer.addLine("B", 1, false, 3);
        var sums = BonManagerClass.getSumArray();
        var sumBrutto = sums[0];
        var sumNetto = sums[4];
        var sumRebates = sumBrutto - sumNetto + sumProdRebates;
        if (sumRebates > 0 && !showPPUNote) {
            Printer.addLine("B", 1, false, 3);
            Printer.addLine("A", 1, false, 0);
            text = POS.lang.getText("LABELS", "REBATES_SAVINGS_NOTE_1");
            Printer.addElement(text, 20, 2, true, 0, 41);
            bontext = bontext + text;
            Printer.addLine("A", 1, false, 0);
            text = POS.lang.getText("LABELS", "REBATES_SAVINGS_NOTE_2").replace('%amount%', float2StringD2(sumRebates));
            Printer.addElement(text, 20, 2, true, 0, 41);
            bontext = bontext + text;
            Printer.addLine("B", 1, false, 3);
        }

        if (showPPUNote) {
            Printer.addLine("A", 1, false, 0);
            text = POS.lang.getText("LABELS", "PERSONAL_PURCHASE_NOTE_1");
            Printer.addElement(text, 20, 2, true, 0, 41);
            bontext = bontext + text;
            Printer.addLine("A", 1, false, 0);
            text = POS.lang.getText("LABELS", "PERSONAL_PURCHASE_NOTE_2");
            Printer.addElement(text, 20, 2, true, 0, 41);
            bontext = bontext + text;
        }

        if (BonManagerClass.printMode == "paydown" && BonManagerClass.showPaydownNote) {
            Printer.addLine("A", 1, false, 0);
            text = POS.lang.getText("LABELS", "PAYDOWN_NOTE_1");
            Printer.addElement(text, 20, 2, true, 0, 41);
            Printer.addLine("A", 1, false, 0);
            bontext = bontext + text;
            text = POS.lang.getText("LABELS", "PAYDOWN_NOTE_2");
            Printer.addElement(text, 20, 2, true, 0, 41);
            bontext = bontext + text;
        }

        if (withQRCode) {
            var commandbuffer = qrcode.QRCodePOSCommand($, BonManagerClass.currentReceipt.getQRCodeRepresentation());
            Printer.addImageLine(commandbuffer);
            if (BonManagerClass.currentReceipt.jwsSignatureBase64Url == "U2ljaGVyaGVpdHNlaW5yaWNodHVuZyBhdXNnZWZhbGxlbg") {
                Printer.addLine("A", 1, false, 0);
                text = 'Sicherheitseinrichtung ausgefallen';
                Printer.addElement(text, 20, 2, true, 0, 41);
            }
        }

        return $.when(Printer.foot()).then(function () {
            // e-Beleg (§ 132a BAO): Bon mitschneiden und Belegart
            // dokumentieren, BEVOR print() den Zeilenpuffer leert.
            var ausgabe = eBelegVorDruck(BonManagerClass, Printer, withQRCode, ReceiptID);
            if (ausgabe.papier)
                Printer.print();
            else
                Printer.reset();

            if (BonManagerClass.printMode == "bill")
                Trans.updateClosedField(BonManagerClass.currentBonId, -2);

            BonManagerClass.printMode = "normal";
            defret.resolve(bontext);
        });
    }

    $.when(stepPrintHeader())
        .then(stepReclamationHeaderAndScanEntries)
        .then(stepBuildHeaderTextAndEntries)
        .then(stepRedrawSumAndVoucher)
        .then(stepBonIdAndUserParams);

    return defret.promise();
}

CReceiptPrinter.prototype.getDisplayName = function (name) {
    if (name) {
        var nameParts = name.split(" ");
        if (nameParts.length < 2)
            return name;

        var surname = nameParts[nameParts.length - 1];

        var displayName = "";
        for (var i = 0; i < nameParts.length - 1; i++)
            displayName += nameParts[i] + " ";

        displayName += surname[0] + ".";
    } else {
        displayName = "";
    }
    return displayName;
}

CReceiptPrinter.prototype.getStatus = function (mode) {
    return Printer.getStatus(mode);
}

CReceiptPrinter.prototype.isPaperPresent = function () {
    return true;
    var status = Printer.getStatus("paper");

    if (status[6] == 0)
        return true;
    else
        return false;
}

export { inBelegReihe };
export { CReceiptPrinter };
